import {
  Row, Container, Card, Col
} from "react-bootstrap";
import { Page } from "@whitespace/whitespace-ui";
import {
  IconPermission,
  IconType,
  IconTypeClass,
  IconTypeComponent,
  IconTypeDescription,
  IconTypeLink
} from "interfaces/components/IHwrcIconLink";
import HwrcIconLink from "components/HwrcIconLink/HwrcIconLink";
import { CheckPermissions } from "modules/CheckPermissions";
import { useStateMachine } from "little-state-machine";

const Settings = () => {
  const { state } = useStateMachine();

  return (
    <Page>
      <Card>
        <Card.Header>
          <div className="float-start">
            <h2 data-testid="settings">Settings</h2>
          </div>
        </Card.Header>
        <Card.Body className="no-padding settings">
          <section>
            <Container fluid>
              <Row className="mb-4">
                {(Object.keys(IconType) as Array<keyof typeof IconType>).map(
                  key => {
                    const iconIndex: IconType = IconType[key as keyof typeof IconType];
                    if (
                      CheckPermissions(
                        state.userRole!,
                        IconPermission[iconIndex]
                      )
                    ) {
                      return (
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          data-testid={IconTypeClass[iconIndex]}
                          key={iconIndex}
                        >
                          <HwrcIconLink
                            iconClass={IconTypeClass[iconIndex]}
                            iconLink={IconTypeLink[iconIndex]}
                            iconDescription={IconTypeDescription[iconIndex]}
                            iconComponent={IconTypeComponent[iconIndex]}
                          />
                        </Col>
                      );
                    }

                    return <span key={iconIndex} />;
                  }
                )}
              </Row>
            </Container>
          </section>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default Settings;
